import { findSubsidyTag } from '@lambda/reebelo/src/tagHelpers';
import { priceFormater } from '@/settings/index';
import PriceInformation from '@/components/products/PriceInformation';
import PurchaseLinks from '@/components/products/PurchaseLinks';
import ComparePriceInformationNew from '@/components/products/ComparePriceInformationNew';
import { priceFormatSuperscript } from '@/lib/price';
import i18n from '@/settings/i18n';
import {
  ReplacedProduct,
  SelectionT,
} from '@/lib/collections/catalogue/helpers';
import { ShippingData } from '../collections/[handle]/NewProductPage/types';
import { DeliveryDateResponse } from '@/api/products/delivery-date';

const t = i18n.init();

type TopBarT = {
  productTitle: string;
  selection: SelectionT;
  purchaseLinkOffer: ReplacedProduct;
  comparePrice: number | undefined;
  warrantyID: number | null;
  shippingData: ShippingData;
  deliveryDate: DeliveryDateResponse | undefined;
  isUnfitProduct: boolean;
  totalPrice: number;
  isTradeInEligible: boolean;
  categoryPk: string;
};

const TopBar = ({
  productTitle,
  selection,
  purchaseLinkOffer,
  comparePrice,
  warrantyID,
  shippingData,
  deliveryDate,
  isUnfitProduct,
  totalPrice,
  isTradeInEligible,
  categoryPk,
}: TopBarT) => (
  <div className="fixed left-0 top-0 z-[49] w-full bg-white py-4 drop-shadow-md lg:drop-shadow-md">
    <div className="reebelo-container flex items-center">
      <div className="flex w-1/2 flex-col">
        <h1 className="w-full text-base font-extrabold leading-5">
          {productTitle}
        </h1>
        <p className="w-full text-xs">
          {selection.condition?.replace('Very Good', 'Good')}
        </p>
      </div>
      <div className="flex w-1/2 items-center justify-end">
        <div className="mr-3 flex flex-col items-end justify-end gap-x-2">
          {comparePrice ? (
            <PriceInformation
              isTradeInEligible={isTradeInEligible}
              actualPrice={totalPrice}
              comparePrice={comparePrice}
              view={'stickyBar'}
            />
          ) : (
            <>
              <p className="block text-right text-xl font-bold text-gray-700">
                {priceFormatSuperscript(priceFormater.long(totalPrice))}
              </p>
              <div className="flex">
                <ComparePriceInformationNew
                  comparePrice={comparePrice}
                  actualPrice={totalPrice}
                  className="text-right text-xxs"
                />
              </div>
            </>
          )}
        </div>
        <PurchaseLinks
          offer={purchaseLinkOffer}
          category={
            purchaseLinkOffer.productType || purchaseLinkOffer.categories?.[0]
          }
          vendor={purchaseLinkOffer.vendor}
          warranty={warrantyID}
          shippingData={shippingData}
          deliverBy={{
            min: deliveryDate?.standard.minDeliveryDate || '',
            max: deliveryDate?.standard.maxDeliveryDate || '',
          }}
          subsidyTag={findSubsidyTag(purchaseLinkOffer.tags)}
          productId={purchaseLinkOffer.productId}
          variantId={purchaseLinkOffer.variantId}
          key={`${purchaseLinkOffer.productId}#${purchaseLinkOffer.vendor}`}
          categoryPk={categoryPk}
          cartButtonVariant="dark"
          upgradation={
            purchaseLinkOffer.replacedFromCondition
              ? `${t(selection?.condition as string)} ${t`to`} ${t(
                  purchaseLinkOffer.replacedFromCondition as string,
                )}`
              : undefined
          }
          comparePrice={comparePrice}
          className="grid w-full max-w-[180px] grid-cols-1 gap-1.5 py-0.5 sm:px-1.5"
          isOutOfStock={isUnfitProduct}
        />
      </div>
    </div>
  </div>
);

export default TopBar;
